import {
    CREATE_ACCESS_POINTS_ACCESS_METHOD,
    CREATE_ACCESS_POINTS_ACCESS_METHOD_FAILURE,
    CREATE_ACCESS_POINTS_ACCESS_METHOD_SUCCESS,
} from 'store/actions/types';

export const createAccessPointAccessMethod = (payload) => {
    return {
        type: CREATE_ACCESS_POINTS_ACCESS_METHOD,
        payload: payload,
    };
};

export const createAccessPointAccessMethodFailure = (error) => {
    return {
        type: CREATE_ACCESS_POINTS_ACCESS_METHOD_FAILURE,
        error: error,
    };
};

export const createAccessPointAccessMethodSuccess = (response) => {
    return {
        type: CREATE_ACCESS_POINTS_ACCESS_METHOD_SUCCESS,
        response: response,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/accessPoints/access-methods/create/createAccessPointAccessMethod.js